import styled from "styled-components";

export const Form = styled.form<{ ref }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 101px;
  height: 101px;
`;
